"use strict";
const angular = require("angular");

export class AddIncidentController {
  dateOptions = {
    maxDate: new Date(),
    minDate: new Date(1900, 1, 1),
    startingDay: 1
  };

  datePickerValue;
  incident = {
    reportStatus: "In Progress",
    severity: "Incident"
  };
  error = null;

  /*@ngInject*/
  constructor(appConfig, $uibModalInstance, $state, $http, moment) {
    "ngInject";

    this.constants = appConfig;
    this.incidentType = appConfig.incidentType;
    this.severities = appConfig.severities;
    this.message = "Hello";
    this.modal = $uibModalInstance;
    this.$http = $http;
    this.$state = $state;
    this.moment = moment;
  }

  updateDate() {
    console.log("DatePickerValue changed: ", this.datePickerValue);
    const date = this.moment(this.datePickerValue);
    this.incident.date = date.format("YYYY-MM-DD");

    this.updateDateTime();

    const month = date.month() + 1;
    let year = date.year();
    console.log("month is: ", month);
    if (month > 9) year++;

    console.log("set season to: ", year);
    this.incident.season = year;
  }

  updateDateTime() {
    let datetime = this.datePickerValue;

    if (datetime) {
      if (this.timehours && this.timemins) {
        this.incident.time = this.timehours + ":" + this.timemins;
      }

      if (this.incident.time) {
        let item = this.incident.time.split(":");
        let hours = item[0];
        let minutes = item[1];

        datetime.setHours(hours);
        datetime.setMinutes(minutes);
      }

      this.incident.datetime = datetime;
    }
  }

  create() {
    console.log("create");

    let missing = [];

    if (!this.incident.date) {
      missing.push("Date");
    }
    if (!this.incident.title) {
      missing.push("Title");
    }
    if (!this.incident.incidentType) {
      missing.push("Incident Type");
    }
    if (!this.incident.severity) {
      missing.push("Severity");
    }

    if (missing.length > 0) {
      this.error = `Cannot create incident, the following are required: ${missing}`;
      return;
    }

    this.$http.post("/api/incidents/", this.incident).then(result => {
      console.log("rsp:", result);
      this.$state.go("incident", { id: result.data.id });
      this.modal.close();
    });
  }
}

export default angular
  .module("hccApp.addIncident", [])
  .controller("AddIncidentController", AddIncidentController).name;



// WEBPACK FOOTER //
// ./client/app/incident/addIncident.controller.js